import { useEffect, useRef } from 'react';

export const useDiceRollSound = (active, muted, volume) => {
  const audio = useRef(null);
  useEffect(() => {
    if (!active || muted || volume <= 0) return;
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return;
    const context = audio.current || (audio.current = new Audio());
    const level = Math.min(100, Math.max(0, Number(volume))) / 100;
    context.resume().catch(() => {});
    let cancelled = false, timer, count = 0;
    const tick = () => {
      if (cancelled) return;
      const buffer = context.createBuffer(1, Math.floor(context.sampleRate * .018), context.sampleRate), samples = buffer.getChannelData(0);
      for (let i = 0; i < samples.length; i += 1) samples[i] = (Math.random() * 2 - 1) * (1 - i / samples.length) ** 3;
      const source = context.createBufferSource(), filter = context.createBiquadFilter(), gain = context.createGain(); source.buffer = buffer;
      filter.type = 'bandpass'; filter.frequency.value = [1500, 1900, 1250][count % 3]; filter.Q.value = .7;
      gain.gain.setValueAtTime(.12 * level, context.currentTime); gain.gain.exponentialRampToValueAtTime(.0001, context.currentTime + .021);
      source.connect(filter); filter.connect(gain); gain.connect(context.destination); source.start(); source.stop(context.currentTime + .022);
      source.onended = () => { source.disconnect(); filter.disconnect(); gain.disconnect(); };
      count += 1; timer = setTimeout(tick, Math.min(110, 52 + count * 4));
    };
    tick();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [active, muted, volume]);
  useEffect(() => () => { const current = audio.current; audio.current = null; current?.close().catch(() => {}); }, []);
};